import { IActionCallout } from "app/bfx-element-library/models/CalloutModel";

/**
 * settings for all buttons in th Execution Monitor
 */
export type ActionButtons<T> = {
  modify: T;
  pause: T;
  resume: T;
  fillNow: T;
  cancel: T;
};

/**
 * View data model for execution monitor
 */
export type ViewDataModel = {
  totalExecutedLabel: string;
  totalExecuted: string;
  totalRemaining: string;
  prePipsPricePart: string;
  pipsPricePart: string;
  postPipsPricePart: string;

  orderState: string;

  /** CSS class for order state badge */
  panelIntent: string;

  /** booleans for each button indicating if they are enabled */
  buttonEnabled: ActionButtons<boolean>;
  /** booleans for each button indicating if they are visible */
  buttonVisible: ActionButtons<boolean>;

  /** Progress value and label */
  progressBar: { value: number; valueStr: string; label: string };

  useCallout: boolean;
  localActionCallout?: IActionCallout;

  /** Can we still see and monitor the order? */
  hasVisibility: boolean;
};

/**
 * Model for all labels used in the view
 */
export type ExecutionMonitorLabels = {
  buttons: ActionButtons<string> & { info: string };
  totals: {
    totalBuy: string;
    totalSell: string;
    totalRemaining: string;
    percentFilled: string;
  };
};

/** Keys for all the labels used in the Execution Monitor view */
export const LABEL_KEYS: ExecutionMonitorLabels = {
  buttons: {
    info: "execution_monitor.btn_info",
    modify: "execution_monitor.btn_modify",
    pause: "execution_monitor.btn_pause",
    resume: "execution_monitor.btn_resume",
    fillNow: "execution_monitor.btn_fill_now",
    cancel: "execution_monitor.btn_cancel",
  },
  totals: {
    totalBuy: "execution_monitor.total_bought",
    totalSell: "execution_monitor.total_sold,",
    totalRemaining: "execution_monitor.total_remaining",
    percentFilled: "execution_monitor.percent_filled",
  },
};
